/**
 * Created by Administrator on 2019/12/18.
 */
export default {
    so_click(page, module, item, day, type, action){
        // if (page == "home")//首页
        // {
        //     if (module == "register") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "d0700ce2-07a3-4607-8a06-b63f77bd365c",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '参会报名', 'type': '1'}]})
        //     }
        //     else if (module == "order") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "46db4ab1-c943-4aa5-a934-a68d044ddf54",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '预约直播', 'type': '1'}]})
        //     }
        //     else if (module == "查看全部") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "18a4a5c1-7f25-4c68-9278-3bc0a019b834",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{'name': 'link_text', 'value': type + '-查看全部', 'type': '1'}]
        //         })
        //     }
        //     else if (module == "heavyNews")//重磅资讯点击
        //     {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "eb2638f1-b91a-4a1c-bb1b-ada9aaf1dd9a",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': item, 'type': '1'}]})
        //     }
        //     else if (module == "agendaLive")//议程直播
        //     {
        //         if (day) {
        //             if (item)//点击议程直播
        //             {
        //                 sino("event", "b", {
        //                     "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                     "elementId": "6f448b93-099f-429e-8a87-59fbb43aa6f6",
        //                     "intractiveType": "网页",
        //                     "behaviorType": "点击"
        //                 }, {'attribute': [{'name': 'link_text', 'value': "直播-" + day+"-"+item, 'type': '1'}]})
        //             }
        //             else {//点击日期
        //                 sino("event", "b", {
        //                     "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                     "elementId": "81e3576b-9534-4f69-aa91-6c4c35867f47",
        //                     "intractiveType": "网页",
        //                     "behaviorType": "点击"
        //                 }, {'attribute': [{'name': 'link_text', 'value': "直播-" + day, 'type': '1'}]})
        //             }
        //         }
        //     }
        //     else if (module == "partner") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "8bde4367-3935-49b2-80c6-5dcd0c17d724",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': item.title, 'type': '1'}]})
        //     }
        //     else if (module == "agenda") {
        //         if (item) {
        //             var tag = item.m_tag ? item.m_tag.join(',') : "";
        //             sino("event", "b", {
        //                 "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                 "elementId": "b7e0cdf1-c90f-432e-a151-c198bea12123",
        //                 "intractiveType": "网页",
        //                 "behaviorType": "点击"
        //             }, {
        //                 'attribute': [{'name': 'link_text', 'value': day + "-" + type + "-" + item.name, 'type': '1'}, {
        //                     'name': 'S_a_type',
        //                     'value': tag,
        //                     'type': '1'
        //                 }]
        //             })
        //         }
        //         else if (type) {
        //             sino("event", "b", {
        //                 "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                 "elementId": "6ea4ff63-a1e2-4d4c-a637-e3965d98bff3",
        //                 "intractiveType": "网页",
        //                 "behaviorType": "点击"
        //             }, {'attribute': [{'name': 'link_text', 'value': day + "-" + type, 'type': '1'}]})
        //         }
        //         else {
        //             sino("event", "b", {
        //                 "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                 "elementId": "82df59b2-8db0-40af-8cb7-a3b53eccceff",
        //                 "intractiveType": "网页",
        //                 "behaviorType": "点击"
        //             }, {'attribute': [{'name': 'link_text', 'value': day, 'type': '1'}]})
        //         }
        //
        //     }
        //     else if (module == "news") {
        //         var tag = "";
        //         for (var field in item.extra) {
        //             if (item.extra[field].name == "标签" && item.extra[field].value) {
        //                 tag = JSON.parse(item.extra[field].value).join(",");
        //             }
        //         }
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "fbd20f71-137c-494c-b39a-56022706cb4d",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [
        //                 {'name': 'link_text', 'value': item.title, 'type': '1'},
        //                 {
        //                     'name': 'S_a_type',
        //                     'value': tag,
        //                     'type': '1'
        //                 }]
        //         })
        //     }
        //     else if (module == "exhibition") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "c74b5bd6-96b6-4dbb-b40a-775a826ea3ca",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '首页-展览', 'type': '1'}]})
        //     }
        //     else if (module == "guide") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "78c0338b-a0ca-465e-8067-9fd13e3c1eb5",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '首页-参会指南', 'type': '1'}]})
        //     }
        //     else if (module == "下载众筹方案")//下载众筹方案
        //     {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "00648c09-e99b-4b84-855d-b36348ada9a3",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '下载众筹方案', 'type': '1'}]})
        //     }
        //     else if (module == "发送材料到邮箱")//发送材料到邮箱
        //     {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "021029a2-be86-4037-8916-b829fd5ffffa",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '发送材料到邮箱', 'type': '1'}]})
        //     }
        //     else if (module == "发送邮箱") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "47925047-a54e-45be-9402-085ec2ba89a9",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{'name': 'email', 'value': item, 'type': '1'}, {
        //                 'name': 'link_text',
        //                 'value': '发送邮箱确认',
        //                 'type': '1'
        //             }]
        //         })
        //     }
        //
        // }
        // else if (page == "agenda")//议程
        // {
        //     if (module == "search") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "cc0db778-9d3b-40f2-a2f5-27637bf05b78",
        //             "intractiveType": "网页",
        //             "behaviorType": "搜索"
        //         }, {'attribute': [{'name': 'Search_content', 'value': item, 'type': '1'}]})
        //     }
        //     else if (module == "date") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "7df43d8e-77a3-4aee-87ec-b7f5810c1a07",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': day, 'type': '1'}]})
        //     }
        //     else if (module == "type") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "17d1fe99-9253-4bd7-8308-e9d53fc27f8a",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': day + "-" + type, 'type': '1'}]})
        //     }
        //     else {
        //         var tag = item.m_tag ? item.m_tag.join(',') : "";
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "c807f79c-cb3c-4a25-943d-c8aaa0ef7dfb",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{'name': 'link_text', 'value': day + "-" + type + "-" + item.name, 'type': '1'}, {
        //                 'name': 'S_a_type',
        //                 'value': tag,
        //                 'type': '1'
        //             }]
        //         })
        //     }
        //
        // }
        // else if (page == "guide") {
        //     sino("event", "b", {
        //         "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //         "elementId": "4a3fa7ce-4938-4bdb-8e32-24494e45c6e9",
        //         "intractiveType": "网页",
        //         "behaviorType": "点击"
        //     }, {'attribute': [{'name': 'link_text', 'value': '进入百度地图', 'type': '1'}]})
        // }
        // else if (page == "files")//资料中心
        // {
        //     if (action == "下载") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "3070913b-6a9e-4ea3-a3b7-e3f954ac592d",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{
        //                 'name': 'link_text',
        //                 'value': type + " - " + module + " - " + item + "- 下载",
        //                 'type': '1'
        //             }]
        //         })
        //
        //     }
        //     else if (action == "预览") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "3070913b-6a9e-4ea3-a3b7-e3f954ac592d",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{
        //                 'name': 'link_text',
        //                 'value': type + " - " + module + " - " + item + "- 预览",
        //                 'type': '1'
        //             }]
        //         })
        //     }
        //     else if (item && module == "")//点击峰会分论坛议程
        //     {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "87f8596c-895c-49be-b7bb-ce46d8f2b2a7",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': type + " - " + item, 'type': '1'}]})
        //     }
        //     else if (item && module == "去注册") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "30bb85ae-cf00-4df1-ac17-d28c66bf59c4",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '官网下载资料-去注册', 'type': '1'}]})
        //     }
        //     else if (!item) { //点击tab
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "008a6d73-d27e-48fd-b5d2-877e331560f0",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': type, 'type': '1'}]})
        //     }
        //
        // }
        // else if (page == "exhibition") {
        //     if (module == "search") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "6801c7ab-bc71-4127-84bb-2377883426a5",
        //             "intractiveType": "网页",
        //             "behaviorType": "搜索"
        //         }, {'attribute': [{'name': 'Search_content', 'value': item, 'type': '1'}]})
        //     }
        //     else if (module == "展区" || module == "数字之城") {//切换Tab
        //         if (item) {
        //             sino("event", "b", {
        //                 "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                 "elementId": "cfc8d707-4ffc-4aa7-a5a4-96ddd0df7953",
        //                 "intractiveType": "网页",
        //                 "behaviorType": "点击"
        //             }, {
        //                 'attribute': [{
        //                     'name': 'link_text',
        //                     'value': module + " - " + item.title + " - 查看详情",
        //                     'type': '1'
        //                 }]
        //             })
        //         }
        //         else {
        //             sino("event", "b", {
        //                 "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //                 "elementId": "d7db9ad8-af8e-4486-81ad-b8819a38b136",
        //                 "intractiveType": "网页",
        //                 "behaviorType": "点击"
        //             }, {'attribute': [{'name': 'link_text', 'value': module, 'type': '1'}]})
        //         }
        //     }
        //
        // }
        // else if (page == "exhibitionDetail") {
        //     if (module == "去注册") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "3ae0bd92-463e-4c66-ba6c-63b2742fa70b",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '官网下载资料-去注册', 'type': '1'}]})
        //     }
        //     else if (action) {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "38b3a1a4-14a7-4252-aaa1-b76df1d4b759",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{
        //                 'name': 'link_text',
        //                 'value': type + " - " + module + " - " + item + " - " + action,
        //                 'type': '1'
        //             }]
        //         })
        //     }
        // }
        // else if (page == "samplePoint") {
        //     if (module == "去注册") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "3ae0bd92-463e-4c66-ba6c-63b2742fa70b",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '官网下载资料-去注册', 'type': '1'}]})
        //     }
        //     else if (action) {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "38b3a1a4-14a7-4252-aaa1-b76df1d4b759",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {
        //             'attribute': [{
        //                 'name': 'link_text',
        //                 'value': type + " - " + module + " - " + item + " - " + action,
        //                 'type': '1'
        //             }]
        //         })
        //     }
        // }
        // else if (page == "news") {//大会资讯
        //     var tag = "";
        //     for (var field in item.extra) {
        //         if (item.extra[field].name == "标签" && item.extra[field].value) {
        //             tag = JSON.parse(item.extra[field].value).join(",");
        //         }
        //     }
        //     sino("event", "b", {
        //         "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //         "elementId": "b26eeff9-1527-4d87-a8aa-12f8c0813e0b",
        //         "intractiveType": "网页",
        //         "behaviorType": "点击"
        //     }, {
        //         'attribute': [{'name': 'link_text', 'value': item.title, 'type': '1'}, {
        //             'name': 'S_a_type',
        //             'value': tag,
        //             'type': '1'
        //         }]
        //     })
        // }
        // else if (page == "partner") {
        //     sino("event", "b", {
        //         "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //         "elementId": "1017b82f-8402-4d1d-a38c-52cb72655503",
        //         "intractiveType": "网页",
        //         "behaviorType": "点击"
        //     }, {
        //         'attribute': [{'name': 'title', 'value': item.title, 'type': '1'}, {
        //             'name': 'link_text',
        //             'value': item.title + "-" + module,
        //             'type': '1'
        //         }]
        //     })
        // }
        // else if (page == "guest") {
        //     sino("event", "b", {
        //         "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //         "elementId": "978abb61-933b-49dc-af12-c9095b97997b",
        //         "intractiveType": "网页",
        //         "behaviorType": "点击"
        //     }, {'attribute': [{'name': 'link_text', 'value': item.name, 'type': '1'}]})
        // }
        // else //公共部分
        // {
        //     if (module == "clue")//线索按钮点击
        //     {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "b4858cec-80f7-4564-b36f-4b0307702db6",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '线索按钮', 'type': '1'}]})
        //     }
        //     else if (module == "clue_填写需求") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "aaf01166-c260-4b16-be4b-29fd2e4d4a57",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '反馈需求', 'type': '1'}]})
        //     }
        //     else if (module == "clue_在线咨询") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "160d2b9a-1302-4ce1-b1e4-d23faafb4b77",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '产品&方案咨询', 'type': '1'}]})
        //     }
        //     else if (module == "联系我们_APP") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "59b0705e-e34e-43e3-a917-896c80eb18cd",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': 'APP', 'type': '1'}]})
        //     }
        //     else if (module == "联系我们_微信") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "3632ed74-c9ef-4c34-bd82-079e8a89c152",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '微信', 'type': '1'}]})
        //     }
        //     else if (module == "联系我们_微博") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "d368b23a-4796-49cc-96bc-1b174cf99097",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': '微博', 'type': '1'}]})
        //     }
        //     else if (module == "联系我们_Linkedin") {
        //         sino("event", "b", {
        //             "appId": "2cf22ab2-b7e8-44cb-b591-6078d617f893",
        //             "elementId": "4c1e2fe9-b99c-4a8a-aa46-929dbc98928b",
        //             "intractiveType": "网页",
        //             "behaviorType": "点击"
        //         }, {'attribute': [{'name': 'link_text', 'value': 'in', 'type': '1'}]})
        //     }
        //
        // }
    }
}
